import { useEffect } from 'react';
import { flushOutbox } from '@/lib/offlineOutbox';

/**
 * No UI. Mounted once in App.jsx's AppShellLayout so the offline outbox
 * flushes automatically regardless of which screen the rep is on when
 * signal returns, not only while Home (which renders the pending count) is
 * mounted.
 *
 * Three triggers: the browser's 'online' event, a periodic check (the
 * 'online' event is known to be unreliable in a backgrounded mobile
 * browser tab, so this is the real primary mechanism), and Home's own
 * "Sync Now" tap, which calls flushOutbox directly rather than through here.
 */
const FLUSH_INTERVAL_MS = 25_000;

export default function OutboxSync() {
  useEffect(() => {
    flushOutbox();
    window.addEventListener('online', flushOutbox);
    const interval = setInterval(flushOutbox, FLUSH_INTERVAL_MS);
    return () => {
      window.removeEventListener('online', flushOutbox);
      clearInterval(interval);
    };
  }, []);

  return null;
}
